import { LETTER_SENDER_PROVIDER_CONFIG, LetterSenderProviders } from './constants';
import { DEFAULT_LETTER_SENDER_CONFIG } from './constants.defaults';

export const isLetterSenderEHRProvider = (provider?: string | null) => {
  if (!provider) return false;
  return LetterSenderProviders.includes(provider);
};

export const getLetterSenderConfig = (provider?: string | null) => ({
  ...DEFAULT_LETTER_SENDER_CONFIG,
  ...(provider && isLetterSenderEHRProvider(provider)
    ? LETTER_SENDER_PROVIDER_CONFIG[provider]
    : undefined),
});
